import src from "IMAGE";
export default { src, width: 335, height: 223, blurWidth: 0, blurHeight: 0};
